import script from "./SensorNormalizationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorNormalizationsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorNormalizationsView.vue?vue&type=style&index=0&id=1ebca9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebca9ec"]])

export default __exports__